module.exports = __webpack_public_path__ + "img/locate-cp.305073ee.png";